module.exports = __webpack_public_path__ + "img/logo_dark.f0753106.svg";